export default __webpack_public_path__ + "static/media/alcohol_cat_disabled.56e781da.png";